//Renders labels to a PDF file

export const inchesToPoints = (inches: number) => {
  return inches * 72;
};
export const pointsToInches = (points: number) => {
  return points / 72;
};
